export default {"src":"/_next/static/media/MY.f645661a.svg","height":34,"width":50,"blurWidth":0,"blurHeight":0};